import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { UserActionTypes } from "../../../../store/actions/types";
import { RootState } from "../../../../store";
import { login } from "../../../../store/actions/userActions";
import { selectUserSlice, selectUserValue } from "../../../../selectors";

const mapper = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  login: (email: string, password: string) => {
    login(dispatch, email, password);
  },
  reset: () => {
    dispatch({ type: UserActionTypes.RESET_FORM });
  },
});

const props = (state: RootState) => ({
  user: selectUserValue(state),
  loginStatus:
    selectUserSlice(state).error === "credentials_wrong"
      ? "pwWrong"
      : selectUserSlice(state).loginStatus,
});

export const connector = connect(props, mapper);
